import { render, staticRenderFns } from "./payOk.vue?vue&type=template&id=54b05dae&scoped=true&"
import script from "./payOk.vue?vue&type=script&lang=js&"
export * from "./payOk.vue?vue&type=script&lang=js&"
import style0 from "./payOk.vue?vue&type=style&index=0&id=54b05dae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b05dae",
  null
  
)

component.options.__file = "payOk.vue"
export default component.exports